import React, {
  type ReactElement,
  useCallback,
  useMemo,
  useState,
} from 'react';
import { Flex } from '@banhala/ui-kit';
import { WebView } from './WebWebView.web';

const heightInjectJavascript = `(function () {
  if (window.__RN_HEIGHT_OBSERVER__) return;
  window.__RN_HEIGHT_OBSERVER__ = true;

  let lastHeight = 0;

  function postHeight() {
    const height = Math.ceil(
      document.documentElement.scrollHeight ||
      document.body.scrollHeight
    );

    if (height === lastHeight) return;
    lastHeight = height;

    window.parent.postMessage(
      JSON.stringify({
        type: 'HEIGHT_CHANGE',
        height,
      })
    );
  }

  const ro = new ResizeObserver(postHeight);
  ro.observe(document.body);

  window.addEventListener('load', postHeight);
  postHeight();
})();`;

export const ContentWebView: React.FC<{
  source: { html?: string; uri?: string };
  onChangeHeight?: (height: number) => void;
  Footer?: ReactElement;
}> = props => {
  const [webviewHeight, setWebviewHeight] = useState<number>(200);

  // 개발 환경에서 CORS 우회를 위해 이미지 URL 변환
  const transformedHtml = useMemo(() => {
    // if (props.source.html) {
    //   return transformImageUrls(props.source.html);
    // }
    return props.source.html;
  }, [props.source.html]);

  const onWebViewMessage = useCallback<
    (event: { data?: string }) => void
  >(() => {}, []);

  if (transformedHtml && transformedHtml.length > 0) {
    return (
      <Flex
        onLayout={({ nativeEvent }) => {
          const { height } = nativeEvent.layout;
          if (webviewHeight !== height) {
            props.onChangeHeight?.(height);
            setWebviewHeight(height);
          }
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: transformedHtml }}></div>

        {props.Footer}
      </Flex>
    );
  }

  if (props.source.uri) {
    return (
      <WebView
        // ref={ref}
        source={{ uri: props.source.uri, method: 'GET' }}
        // originWhitelist={['*']}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        onMessage={onWebViewMessage}
        scrollEnabled={false}
        // javaScriptEnabled={true}
        // cacheEnabled={true}
        // onLoadEnd={() => {
        // ref.current?.injectJavaScript(heightInjectJavascript);
        //}}
        injectedJavaScript={heightInjectJavascript}
        // style={{ height: 800 }}
        style={{ height: webviewHeight }}
      />
    );
  }
  return null;
};
